import React, { useState } from 'react';
import { supabase } from '../../supabaseClient';

const ModalSugerencias = ({ session, nickname, onClose }) => {
  const [tipo, setTipo] = useState('sugerencia');
  const [mensaje, setMensaje] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [error, setError] = useState('');

  const handleEnviar = async () => {
    if (!mensaje.trim()) { setError('Escribí algo antes de enviar.'); return; }
    setEnviando(true);
    setError('');
    const { error: err } = await supabase.from('sugerencias').insert({
      user_id: session.user.id,
      nickname: nickname || session.user.email.split('@')[0],
      tipo,
      mensaje: mensaje.trim(),
    });
    setEnviando(false);
    if (err) { setError('Error al enviar. Intentá de nuevo.'); return; }
    setEnviado(true);
  };

  const TIPOS = [
    { value: 'sugerencia', label: '💡 Sugerencia', color: '#00f2ff' },
    { value: 'bug',        label: '🐛 Bug',        color: '#ef4444' },
    { value: 'otro',       label: '💬 Otro',        color: '#a855f7' },
  ];

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(8px)',
      zIndex: 99999, display: 'flex', alignItems: 'center', justifyContent: 'center',
    }} onClick={e => { if (e.target === e.currentTarget) onClose(); }}>

      <div style={{
        background: '#0a0f19', border: '2px solid #00f2ff33',
        borderRadius: '16px', padding: '32px', width: '440px', maxWidth: '90vw',
        boxShadow: '0 0 40px rgba(0,242,255,0.15)',
      }}>
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
          <div>
            <h2 style={{ margin: 0, color: '#fff', fontSize: '1.2rem', letterSpacing: '1px' }}>CONTACTO</h2>
            <p style={{ margin: '4px 0 0', color: '#475569', fontSize: '0.75rem' }}>
              Sugerencias, bugs o cualquier cosa
            </p>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#475569', fontSize: '1.4rem', cursor: 'pointer', lineHeight: 1 }}>×</button>
        </div>

        {enviado ? (
          <div style={{ textAlign: 'center', padding: '24px 0' }}>
            <div style={{ fontSize: '3rem', marginBottom: '12px' }}>✅</div>
            <p style={{ color: '#22c55e', fontSize: '1rem', fontWeight: 'bold', margin: '0 0 8px' }}>¡Mensaje enviado!</p>
            <p style={{ color: '#475569', fontSize: '0.85rem', margin: '0 0 24px' }}>Gracias por el feedback.</p>
            <button onClick={onClose} style={{ background: '#00f2ff20', color: '#00f2ff', border: '1px solid #00f2ff44', padding: '8px 24px', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>
              Cerrar
            </button>
          </div>
        ) : (
          <>
            {/* Selector de tipo */}
            <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
              {TIPOS.map(t => (
                <button key={t.value} onClick={() => setTipo(t.value)} style={{
                  flex: 1, padding: '8px 4px', borderRadius: '8px', cursor: 'pointer',
                  background: tipo === t.value ? t.color + '20' : '#080d14',
                  border: `1px solid ${tipo === t.value ? t.color : '#1e293b'}`,
                  color: tipo === t.value ? t.color : '#64748b',
                  fontSize: '0.75rem', fontWeight: 'bold', transition: '0.2s',
                }}>
                  {t.label}
                </button>
              ))}
            </div>

            {/* Textarea */}
            <textarea
              value={mensaje}
              onChange={e => { setMensaje(e.target.value); setError(''); }}
              placeholder="Contanos qué pensás, qué falla, o qué le agregarías a la app..."
              rows={5}
              style={{
                width: '100%', boxSizing: 'border-box',
                background: '#080d14', border: '1px solid #1e293b',
                borderRadius: '8px', color: '#e2e8f0', fontSize: '0.88rem',
                padding: '12px', resize: 'vertical', outline: 'none',
                fontFamily: 'inherit', lineHeight: 1.5,
              }}
              onFocus={e => e.target.style.borderColor = '#00f2ff44'}
              onBlur={e => e.target.style.borderColor = '#1e293b'}
            />

            {/* Contador de caracteres */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '6px', marginBottom: '16px' }}>
              {error
                ? <span style={{ color: '#ef4444', fontSize: '0.78rem' }}>{error}</span>
                : <span style={{ color: '#334155', fontSize: '0.72rem' }}>
                    De: <strong style={{ color: '#475569' }}>{nickname || session.user.email.split('@')[0]}</strong>
                  </span>
              }
              <span style={{ color: mensaje.length > 800 ? '#ef4444' : '#334155', fontSize: '0.7rem' }}>
                {mensaje.length}/1000
              </span>
            </div>

            {/* Botones */}
            <div style={{ display: 'flex', gap: '10px' }}>
              <button onClick={onClose} style={{
                flex: 1, padding: '10px', borderRadius: '8px', cursor: 'pointer',
                background: 'transparent', border: '1px solid #1e293b', color: '#475569',
                fontWeight: 'bold', fontSize: '0.85rem',
              }}>
                Cancelar
              </button>
              <button
                onClick={handleEnviar}
                disabled={enviando || mensaje.length > 1000}
                style={{
                  flex: 2, padding: '10px', borderRadius: '8px', cursor: enviando ? 'default' : 'pointer',
                  background: enviando ? '#1e293b' : '#00f2ff',
                  border: 'none', color: enviando ? '#475569' : '#000',
                  fontWeight: 'bold', fontSize: '0.88rem', transition: '0.2s',
                }}
              >
                {enviando ? 'Enviando...' : 'Enviar'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ModalSugerencias;